import { Component, effect, inject } from '@angular/core';
import { AuthenticationStore } from '../../states/auth/auth.store';
import { UserProfileStore } from '../../states/user-profile/user-profile.store';
import { PatientStore } from '../../states/patient/patient.store';
import { ProviderStore } from '../../states/provider/provider.store';
import { providerRoutePath } from '../../utils/provider-route.util';

@Component({
  selector: 'app-footer',
  standalone: false,
  templateUrl: './footer.html',
  styleUrl: './footer.css',
})
export class Footer {
  private readonly authStore = inject(AuthenticationStore);
  private readonly userProfileStore = inject(UserProfileStore);
  private readonly patientStore = inject(PatientStore);
  private readonly providerStore = inject(ProviderStore);

  readonly currentYear = new Date().getFullYear();
  readonly supportEmail = 'support@GoCareMo.ph';

  constructor() {
    effect(() => {
      if (!this.authStore.isAuthenticated()) return;

      const role = this.userProfileStore.roleName()?.toLowerCase();
      const personGuid = this.userProfileStore.personGuid();

      if (role === 'patient' && personGuid && !this.patientStore.patient()?.patientGuid) {
        this.patientStore.loadPatientByPersonGuid(personGuid);
      }

      if (role === 'provider' && personGuid && !this.providerStore.provider()?.providerGuid) {
        this.providerStore.loadProviderByPersonGuid(personGuid);
      }
    });
  }

  get canOpenPatientBookings(): boolean {
    const role = this.userProfileStore.roleName()?.toLowerCase();
    return this.authStore.isAuthenticated()
      && role === 'patient'
      && !!this.patientStore.patient()?.patientGuid;
  }

  get patientBookingsRoute(): string[] {
    const patientGuid = this.patientStore.patient()?.patientGuid;
    return patientGuid ? ['/features/patient', patientGuid, 'bookings'] : ['/auth/login'];
  }

  get canOpenProviderDashboard(): boolean {
    const role = this.userProfileStore.roleName()?.toLowerCase();
    return this.authStore.isAuthenticated()
      && role === 'provider'
      && !!this.providerStore.provider()?.providerGuid;
  }

  get providerDashboardRoute(): string {
    const providerGuid = this.providerStore.provider()?.providerGuid;
    return providerGuid
      ? providerRoutePath(providerGuid, 'dashboard')
      : '/auth/login';
  }
}
